import React from 'react';
import PropTypes from 'prop-types';

import '../styles/List.css';
import SubList from './Sublist';

import { convertPlusMinus, convertToIconName } from '../helpers/helperFunctions.js';

import {ReactComponent as AwbIcon} from '../icons/awb-icon.svg';
import {ReactComponent as SetAIcon} from '../icons/set-a-icon.svg';
import {ReactComponent as SetBIcon} from '../icons/set-b-icon.svg';
import {ReactComponent as Tungsten} from '../icons/tungsten-icon.svg';
import {ReactComponent as Kelvin} from '../icons/kelvin-icon.svg';
import {ReactComponent as DaylightIcon} from '../icons/daylight-icon.svg';
import {ReactComponent as AddCheckMark} from '../icons/add-check-mark-icon.svg';
import {ReactComponent as AddOkMark} from '../icons/add-ok-mark-icon.svg';
import {ReactComponent as BackIcon} from '../icons/back-icon.svg';

const icons = {
  addCheckMark:  <AddCheckMark className="Icon-topbar" />,
  addOKMark:  <AddOkMark className="Icon-topbar" />,
  setA: <SetAIcon className="Icon-topbar" />,
  setB: <SetBIcon className="Icon-topbar" />,
  aWB: <AwbIcon className="Icon-topbar" />,
  daylight: <DaylightIcon className="Icon-topbar" />,
  kelvin: <Kelvin className="Icon-topbar" />,
  tungsten: <Tungsten className="Icon-topbar" />,
  back: <BackIcon className="Icon-topbar" />,
}

const List = ({ list, listItemIndex, showSubList, subListItemIndex, rowAmount }) => {
    return (
        <ul className="List-menu">
            {list.map((el, index) => {
            const hasSublist = showSubList === true && index === listItemIndex;
            const dateOptions = {
                year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric',
            };

            const subListHasIcons = el.hasIcons ? true : false;

            const subItemContent = el.type !== 'date_time' && el.type !== 'time_zone'
                ? subListHasIcons 
                ? icons[convertToIconName(el.default)]
                    ? icons[convertToIconName(el.default)]
                    : el.default
                : convertPlusMinus(el.default)
                : el.type === 'date_time' 
                ? new Intl.DateTimeFormat('en-US', dateOptions).format(new Date())
                : new Date().toString().replace("GMT", "UTC").split(" ")[5];

            return (
                    <li className={el.className} key={el.name}>
                        {el.name}
                        {hasSublist ?
                            <SubList
                                subList={el.settings}
                                subItemIndex={subListItemIndex}
                                parentIndex={index}
                                rowAmount={rowAmount}
                                subListHasIcons={el.hasIcons}
                            />
                            :
                            <ul className="Sub-list">
                                <li className="Sub-item">
                                    {subItemContent}
                                </li>
                            </ul>
                        }
                    </li>
                )
  
            })}
      </ul>
    );
  };

List.propTypes = {
    list: PropTypes.arrayOf(PropTypes.object).isRequired,
    listItemIndex: PropTypes.number,
    showSubList: PropTypes.bool,
    subListItemIndex: PropTypes.number,
    rowAmount: PropTypes.number.isRequired,
    subListHasIcons: PropTypes.bool,
}

export default List;
